module.exports = __webpack_public_path__ + "img/south_african.ffbad012.svg";